import React from 'react';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { AccountApiClient } from '../api/account-api-client';
import { UiButton } from '../ui/ui-button';
import { UiDialog } from '../ui/ui-dialog';

import { AccountStatusTransitions } from './admin-panel/account-status-transitions/account-status-transitions';

import { ACCOUNT_STATUS } from '../util/account-status';

type Props = {};

type State = {
  reopeningAccount: boolean;
  selectedAccount: TeamEngineAccount | null;
  accountList: Array<TeamEngineAccount>;
};

export class ReopenAccount extends React.PureComponent<Props, State> {
  state: State = {
    reopeningAccount: false,
    selectedAccount: null,
    accountList: [],
  };

  reopenAccount = () => {
    this.setState({
      reopeningAccount: true,
    });
  };

  closeReopenAccount = () => {
    this.setState({
      reopeningAccount: false,
    });
  };

  searchChange = async (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const response = await AccountApiClient.search({
      status: ACCOUNT_STATUS.CLOSED,
      nameLike: event.currentTarget.value,
    });

    const results = await response.json();

    this.setState({
      accountList: results,
    });
  };

  selectAccount = (event: React.ChangeEvent<{}>, newValue: TeamEngineAccount | null) => {
    this.setState({
      selectedAccount: newValue,
    });
  };

  onStatusTransition = () => {
    this.setState({
      reopeningAccount: false,
      accountList: [],
    });
  };

  renderAccountSearch = () => (
    <Autocomplete
      options={this.state.accountList}
      getOptionLabel={(option) => option.accountName}
      onChange={this.selectAccount}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Find account"
          margin="normal"
          variant="outlined"
          onChange={this.searchChange}
        />
      )}
    />
  );

  renderDialog() {
    const { selectedAccount } = this.state;

    return (
      <UiDialog onClose={this.closeReopenAccount} size="sm" title="Re-open Account">
        <UiDialog.Content>
          {this.renderAccountSearch()}
          {selectedAccount ? (
            <AccountStatusTransitions
              accountId={selectedAccount.accountId}
              onTransition={this.onStatusTransition}
            />
          ) : null}
        </UiDialog.Content>
        <UiDialog.Actions>
          <UiButton onClick={this.closeReopenAccount} variant="dismiss">
            Cancel
          </UiButton>
        </UiDialog.Actions>
      </UiDialog>
    );
  }

  render() {
    const { reopeningAccount } = this.state;

    return (
      <>
        <UiButton variant="secondary" onClick={this.reopenAccount}>
          Re-open Account
        </UiButton>
        {reopeningAccount ? this.renderDialog() : null}
      </>
    );
  }
}
